const NewRecommendations = ["Easiway","Wilflex","PMI"];

export default NewRecommendations;
